(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-our-collection-v2"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('scroll', function () {
    if (window.innerWidth <= 768) {
      const images = document.querySelectorAll('.scaledImage');

      images.forEach(function (image) {
        const scaleValue = 1 + window.scrollY / 3000;
        image.style.transform = `scale(${scaleValue})`;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-our-collection-v3"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('scroll', function () {
    if (window.innerWidth <= 768) {
      const images = document.querySelectorAll('.scaledImage');

      images.forEach(function (image) {
        const scaleValue = 1 + window.scrollY / 3000;
        image.style.transform = `scale(${scaleValue})`;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-our-collection"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('scroll', function () {
    if (window.innerWidth <= 768) {
      const images = document.querySelectorAll('.scaledImage');

      images.forEach(function (image) {
        const scaleValue = 1 + window.scrollY / 3000;
        image.style.transform = `scale(${scaleValue})`;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-tab-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-btn');
    const contents = document.querySelectorAll('.tab-content');
    const buttons = document.querySelectorAll('.tab-button');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const tabId = this.getAttribute('data-tab').split('-')[1];

        tabs.forEach((btn) => btn.classList.remove('active'));
        contents.forEach((content) => content.classList.remove('active'));
        buttons.forEach((btn) => btn.classList.remove('active'));

        document.querySelectorAll('[data-tab="tab-' + tabId + '"]').forEach((el) => {
          el.classList.add('active');
        });

        document.getElementById('tab-' + tabId).classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-content-with-image"] && !Shopify.designMode) return;
  try {
    


  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-btn');
    const contents = document.querySelectorAll('.tab-content');
    const buttons = document.querySelectorAll('.tab-button');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const tabId = this.getAttribute('data-tab').split('-')[1];

        tabs.forEach((btn) => btn.classList.remove('active'));
        contents.forEach((content) => content.classList.remove('active'));
        buttons.forEach((btn) => btn.classList.remove('active'));

        document.querySelectorAll('[data-tab="tab-' + tabId + '"]').forEach((el) => {
          el.classList.add('active');
        });

        document.getElementById('tab-' + tabId).classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-members"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('#team-slider', {
      type: 'loop',
      perPage: 5,
      perSlide: 1,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 2200,
      pauseOnHover: true,
      pauseOnFocus: true,
      breakpoints: {
        767: {
          type: 'loop',
          perPage: 1,
          padding: {
            left: '20%',
            right: '20%',
          },
        },
      },
    });

    splide.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-splide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('#testimonialSplide', {
      type: 'loop',
      perPage: 1,
      arrows: true,
      pagination: false,
      autoplay: true,
      interval: 6000,
      pauseOnHover: true,
      pauseOnFocus: true,
    }).mount();
  });

  } catch(e) { console.error(e); }
})();
})();
